import styled from '@emotion/styled';

export const AccessDeniedWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 50vh;
`;
